import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCountryList extends Layout {
    layoutheaderCountryList: LayoutHeader;
    sourceCountry: DataSource;
    tableCountry: Table;
}
